
<render-highlightable
[inputString]="obj[prop]"
[entryId]="obj.entryId"
[prop]="prop"
[isWholeHighlight]="true"
(click)="highlighter.checkInitWholeHighlight(obj.entryId, prop, obj[prop])"
>
  <span #mathField role="math"></span>
</render-highlightable>
